import './exportable_table.js.coffee';# Added by Script 
Namespace 'Monitoring.Reports.Campaign'

class Monitoring.Reports.Campaign.SentimentByTagView extends Monitoring.Reports.Campaign.ExportableTable
  include @, Monitoring.Reports.Campaign.Utils

  className: 'sentiment-by-tag'
  template: JST['backbone/templates/monitoring/reports/campaign/sentiment_by_tag']

  initialize: (@options = {}) ->
    # just set @options

  render: ->
    @$el.addClass('processing')

    params = @paramsForChildsOfPosts
      exclude_page_owner_generated: true

    $.post('/monitoring/reports/campaign/sentiment_by_tag', params, @_renderData)

  _renderData: (data) =>
    super
    @$el
      .removeClass('processing')
      .html(@template({tags: data}))
    
    @trigger('rendered')